mainApp.component('ruleEditor', {
    templateUrl: '/public/components/rule-editor.component.html',
    bindings: {
        model: '=',
        field: '<',
        id: '<',
        ignoreDisable: '@',
        startOpen: '@',
    },
    controller: function($scope, FieldsService, $state, IconsService, $timeout, $element, UserContextService) {
        const ctrl = this;
        ctrl.show = false;
        ctrl.lock = false;
        ctrl.icons = IconsService.getIcons();
        ctrl.textValue = null;
        ctrl.modelValue = null;

        function hide() {
            if (ctrl.currentType && ctrl.currentType.field) {
                // sending events to clear combo boxes
                $scope.$broadcast('clear-combo', ctrl.model.id + ctrl.field.id);
                $scope.$broadcast('clear-combo', ctrl.model.id + ctrl.currentType.field.type);
            }

            ctrl.locked = false;
            ctrl.show = false;
            ctrl.textValue = null;
            ctrl.modelValue = null;
            ctrl.currentType = null;
            ctrl.errors = null;
        }

        function unlock() {
            $timeout(function() {
                $('body').off('click', unlock);
                hide();
            }, 0);
        }

        ctrl.updateTextValue = function(value, error) {
            ctrl.textValue = value;
            ctrl.errors = error;
        }

        ctrl.selectType = function(value) {
            ctrl.currentType = value;
            $($element[0]).find('.rule-editor-value-wrapper input:first-of-type').focus();
            ctrl.currentSelectedItems = FieldsService.getItems(ctrl.model, ctrl.field, ctrl.currentType.field);
        };

        ctrl.addItem = function(close) {
            ctrl.errors = null;
            let insertedAny = (ctrl.currentType.field && ctrl.currentType.field.type === 'Any') || (ctrl.model[ctrl.field.id][0] && (ctrl.model[ctrl.field.id][0].id == -1 || ctrl.model[ctrl.field.id][0].id == 'Any'));
            if (ctrl.textValue || ctrl.modelValue || insertedAny) {
                let itemAdded = FieldsService.addItem(ctrl.model, ctrl.field, ctrl.currentType.field, ctrl.textValue || ctrl.modelValue, insertedAny);
                if (typeof itemAdded == 'string') {
                    ctrl.errors = itemAdded;
                } else {
                    ctrl.textValue = null;
                    ctrl.modelValue = null;

                    if (ctrl.currentType && ctrl.currentType.field) {
                        $scope.$broadcast('clear-combo', ctrl.model.id + ctrl.currentType.field.type);
                    }
                    if (itemAdded) {
                        $scope.$emit('added-item', {id: ctrl.id, model: ctrl.model});
                    }
                }
            }

            if (close && !ctrl.errors) hide();

        };

        ctrl.broadcastAndSetItem = function (close) {
            ctrl.errors = null; // to display only the relevant error for this item
            $scope.$broadcast('before-adding-item');
            if (!ctrl.errors) {
                ctrl.addItem(close);
            }
        }

        ctrl.disablePort = function () {
            return $ctrl.comboValue === 'ICMP';
        }

        ctrl.setItem = function(value) {
            ctrl.errors = null;
            ctrl.modelValue = value;
        };

        $scope.$on('combo-box-open', function(e, comboId) {
            if (ctrl.currentType && ctrl.currentType.field && comboId === ctrl.model.id + ctrl.field.id) {
                $scope.$broadcast('clear-combo', ctrl.model.id + ctrl.currentType.field.type);
            }
        });

        $scope.$on('show-editor', function(e, fieldId) {
            if (fieldId === ctrl.id + ctrl.field.id) {
                showEditor();
            }
        });

        ctrl.$onInit = function () {
            if (ctrl.startOpen) {
                showEditor();
            }
        }

         function selectOneExistingType(){
                ctrl.currentType = ctrl.field.types[0];
                ctrl.currentSelectedItems = FieldsService.getItems(ctrl.model, ctrl.field, ctrl.currentType.field);
            }

        function showEditor () {
            if (UserContextService.isDisableGUI() && !ctrl.ignoreDisable) return; // if the page is read only don't open the rule editor unless ignoreDisable

            ctrl.show = true;
            ctrl.locked = true;

            $timeout(function() {
                $('body').click(unlock);
            }, 0);


            if(ctrl.field.types.length === 1) {
                selectOneExistingType();
            }
        }

        $scope.$on('hide-editor', function(e, fieldId) {
            if (fieldId === ctrl.id + ctrl.field.id) {
                if (!ctrl.locked) {
                    hide();
                }
            }
        });

        // locking rule editor to set it not to hide when asked to by events (hide-editor)
        ctrl.lock = function($event) {
            $event.stopPropagation();
            ctrl.locked = true;

            $('body').click(unlock);
        };


        ctrl.$onDestroy = function() {
            $('body').off('click', unlock);
        };
    }
});